<template>
  <label class="tw:flex tw:items-center tw:gap-2 tw:m-0">
    <Checkbox
      :disabled="disabled"
      v-bind="$attrs"
    />
    <span
      :class="cn('tw:cursor-pointer', {
        'tw:opacity-50 tw:cursor-not-allowed': disabled,
      })"
    >
      <slot name="label">
        <span class="tw:flex tw:items-center tw:gap-1">
          <span>{{ label }}</span>

          <CustomTooltip
            v-if="tooltipOptions"
            v-bind="tooltipOptions"
            :disabled="disabled"
            class="tw:size-4"
          />
        </span>
      </slot>
    </span>
  </label>
</template>

<script setup>
import CustomTooltip from '@/components/custom-tooltip.vue'
import { cn } from '@/shadcn/lib/utils.js'
import Checkbox from './Checkbox.vue'

defineOptions({
  inheritAttrs: false,
})

defineProps({
  label: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  tooltipOptions: {
    type: Object,
  },
})
</script>
